import React from "react";
import { motion } from "framer-motion";
import {
  staggerContainer,
  staggerItem,
  useMotionPrefs,
  withMotionPrefs,
  cappedStaggerIndex,
  STAGGER_CAP,
  EASE_OUT,
  INSTANT,
} from "@/lib/motion";

export function StaggerRoot({ children, className = "", delay = 0.04, ...props }) {
  const { isReduced } = useMotionPrefs();
  const variants = withMotionPrefs(staggerContainer(delay), isReduced);

  return (
    <motion.div
      className={className}
      variants={variants}
      initial="hidden"
      animate="show"
      {...props}
    >
      {children}
    </motion.div>
  );
}

export function StaggerItem({ children, className = "", index = 0, ...props }) {
  const { isReduced } = useMotionPrefs();
  const capped = cappedStaggerIndex(index);
  const instant = isReduced || index >= STAGGER_CAP;
  const variants = {
    hidden: { opacity: instant ? 1 : 0, y: instant ? 0 : 10 },
    show: {
      opacity: 1,
      y: 0,
      transition: instant ? INSTANT : { duration: 0.28, ease: EASE_OUT },
    },
  };

  return (
    <motion.div className={className} variants={variants} {...props}>
      {children}
    </motion.div>
  );
}
